import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { CompanyNotFoundComponent } from './features/company-not-found/company-not-found.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./core/redirect-to-tenants.component').then(
        (m) => m.RedirectToTenantsComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'embed-checkout',
    loadChildren: () =>
      import('./features/embed-checkout/embed-checkout.routes').then(
        (m) => m.embedCheckoutIframeRoutes,
      ),
  },
  {
    path: 'error/:errcode',
    component: PageNotFoundComponent,
    data: {
      title: 'Error',
    },
  },
  {
    path: 'success/:errcode',
    component: PageNotFoundComponent,
    data: {
      title: 'Success',
    },
  },
  {
    path: 'notfound/:errcode',
    component: CompanyNotFoundComponent,
    data: {
      title: 'Not Found',
    },
  },
  {
    path: 'client',
    loadChildren: () =>
      import('./features/client-booking/tour-appointment.routes').then(
        (m) => m.tourAppointmentRoutes,
      ),
  },
  {
    path: 'tenants/:tenant_uuid/subscriptions/:uuid',
    loadComponent: () =>
      import('./features/client-subscription/manage-subscription/manage-subscription.component').then(
        (c) => c.ManageSubscriptionComponent,
      ),
  },
  {
    path: 'tenants/:tenant_uuid/invoices/:uuid',
    loadComponent: () =>
      import('./features/client-payment/payment-due/payment-due.component').then(
        (c) => c.PaymentDueComponent,
      ),
  },
  {
    path: 'tenants/:tenant_uuid/salesreturns/:uuid',
    loadComponent: () =>
      import('./features/client-payment/salesreturn-view-pdf/salesreturn-view-pdf.component').then(
        (c) => c.SalesReturnViewPdfComponent,
      ),
  },
  {
    path: 'tenants/:tenant_uuid/approval',
    loadChildren: () =>
      import('./features/approval/client-transfer.routes').then(
        (m) => m.clientTransferRoutes,
      ),
  },
  // {
  //     path: 'paylink/:uuid', loadChildren: () => import('./features/client-payment/client-payment.module').then(c => c.ClientPaymentModule)
  // },
  {
    path: 'paylink-callback',
    loadComponent: () =>
      import('./features/callback/callback/callback.component').then(
        (c) => c.CallbackComponent,
      ),
  },
  {
    path: 'checkout',
    loadComponent: () =>
      import('./features/client-subscription/one-page-checkout/one-page-checkout.component').then(
        (c) => c.OnePageCheckoutComponent,
      ),
    data: {
      title: 'Checkout',
    },
  },
  {
    path: 'tenants',
    loadChildren: () =>
      import('./features/client-subscription/client-subscription.routes').then(
        (m) => m.clientSubscriptionRoutes,
      ),
  },
  {
    path: 'tenants/:tenant_uuid',
    loadChildren: () =>
      import('./features/client-subscription/client-subscription.routes').then(
        (m) => m.clientSubscriptionRoutes,
      ),
  },
  {
    path: 'tenants/:tenant_uuid/paylink/:uuid',
    loadChildren: () =>
      import('./features/client-payment/client-payment.routes').then(
        (m) => m.clientPaymentRoutes,
      ),
  },
  {
    path: 'class-booking/:widget_id',
    loadComponent: () =>
      import('./features/class-booking-widget/class-booking-widget.component').then(
        (c) => c.ClassBookingWidgetComponent,
      ),
  },
  {
    path: 'single-page-checkout/:widget_id',
    loadComponent: () =>
      import('./features/embed-checkout/single-page-checkout-embed.component').then(
        (c) => c.SinglePageCheckoutEmbedComponent,
      ),
  },
  {
    path: 'companies/:company_uuid/pb-class-booking-location/:af_location_id',
    loadComponent: () =>
      import('./features/class-booking-widget/class-booking-widget.component').then(
        (c) => c.ClassBookingWidgetComponent,
      ),
  },
  {
    path: 'lead-capture/:widget_id',
    loadComponent: () =>
      import('./features/lead-capture-widget/lead-capture-widget.component').then(
        (c) => c.LeadCaptureWidgetComponent,
      ),
  },
  {
    path: 'tour-booking/:widget_id',
    loadComponent: () =>
      import('./features/tour-booking-widget/tour-booking-widget.component').then(
        (c) => c.TourBookingWidgetComponent,
      ),
  },
  {
    path: 'trial-booking/:widget_id',
    loadComponent: () =>
      import('./features/trial-booking-widget/trial-booking-widget.component').then(
        (c) => c.TrialBookingWidgetComponent,
      ),
  },
  {
    path: 'tenants/:tenant_uuid/forms/:uuid',
    loadComponent: () =>
      import('./features/form-runner/form-runner.component').then(
        (c) => c.FormRunnerComponent,
      ),
    data: {
      title: 'Fill Form',
    },
  },
  {
    path: 'notification-preferences',
    loadComponent: () => import('./features/notification-preferences/notification-preferences.component').then(c => c.NotificationPreferencesComponent),
    data: {
        title: 'Notification Preferences'
    }
  }
];
